export enum DropdownFilterType {
    All,
    Blank,
    NonBlank,
    ByValue
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/interfaces/dropdown-filter-type.ts